export default "__VITE_ASSET__B8NzC7Qa__"